var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"title",attrs:{"primary-title":""}},[_vm._v("Sentiment")]),_vm._v(" "),_c('v-card-text',[(_vm.isMounted)?_c('apexchart',{attrs:{"type":"pie","options":_vm.options,"series":_vm.series,"height":320}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb277ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/ttb/DashboardNonvoice/ReplyComment/Chart.vue
// module id = null
// module chunks = 